import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from 'react';

const TimeCheckContext = createContext<number>(Date.now());

interface ITimeCheckProviderProps {
  checkInMs?: number;
  children: ReactNode;
}

export function TimeCheckProvider({
  children,
  checkInMs = 60000,
}: ITimeCheckProviderProps) {
  const [currentTime, setCurrentTime] = useState(Date.now());

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTime(Date.now());
    }, checkInMs);

    return () => clearInterval(intervalId);
  }, [checkInMs]);

  return (
    <TimeCheckContext.Provider value={currentTime}>
      {children}
    </TimeCheckContext.Provider>
  );
}

export const useCurrentTime = () => useContext(TimeCheckContext);
